import styled from '@emotion/styled';
import { EventHeaderCaptionWrapper } from 'src/domains/sportsbook/webview/components/sportEventsListNew/EventGroupHeaderUnified.style';
import { withConfig } from 'src/withConfig';

export const ComboOverUnderRoot = styled('div', { label: 'ComboOverUnderRoot' })`
    width: 100%;
`;

export const HeaderWrapper = styled(EventHeaderCaptionWrapper, { label: 'HeaderWrapper' })`
    display: grid;
    grid-template-columns: minmax(40px, 0.6fr) repeat(3, 1fr);
    padding: 0;
`;

export const HeaderCell = withConfig(theme => styled('span', { label: 'HeaderCell' })`
    color: ${theme.star.unified.eventHeaderCaption.txtColorSecondary};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.regular};
    width: 100%;
    text-align: center;
    padding: 8px 4px;

    &:first-of-type {
        padding-left: 4px;
    }

    &:last-of-type {
        padding-right: 4px;
    }
`);

export const MarketRows = styled('div', { label: 'MarketRows' })`
    align-items: stretch;
    display: grid;
    grid-template-columns: minmax(40px, 0.6fr) repeat(3, 1fr);
`;

export const LineCell = withConfig(theme => styled('div', { label: 'LineCell' })`
    color: ${theme.star.selectionsGroup.txtColor};
    font-size: ${theme.star.unified.eventRow.typography.fontSizePrimary};
    font-weight: ${theme.star.unified.eventRow.typography.fontWeightSecondary};
    border-bottom: 1px solid ${theme.star.unified.selection.borderColor};
    min-height: 61px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 4px 8px 8px;
`);

export const SelectionCell = withConfig(theme => styled('div', { label: 'SelectionCell' })`
    min-width: 0;
    width: 100%;
    border-bottom: 1px solid ${theme.star.unified.selection.borderColor};
    min-height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    align-self: stretch;
    padding: 6px 4px;

    &:has(+ [class$='LineCell']),
    &:last-of-type {
        padding-right: 8px;
    }

    .selection {
        display: flex;
        justify-content: center;
        flex: 1;
        align-self: stretch;
        min-width: 0;
    }
`);
